<template>
<div class="chapter">
<div class="inner_page">
<p class="sp1" id="epi"> </p>
<p class="ep">If witches could do any such miraculous things,</p>
<p class="ep">as these and other which are imputed to them,</p>
<p class="ep">they might do them again and again,</p>
<p class="ep-bot">at any time or place, or at any man’s desire.</p>
<p class="epc"><span class="epub-b">—Reginald Scot</span></p>
<p class="epc">   <span class="epub-bi">The Discoverie of Witchcraft,</span> <span class="epub-b">1584</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?8c52413a